/* Hawa Drum theme JS — FAQ accordions, marquee, audio players, product gallery + variants */
(function () {
  'use strict';

  /* ── FAQ accordion (works in theme editor too via re-init) ── */
  function initFaq(scope) {
    (scope || document).querySelectorAll('.faq-q').forEach(function (q) {
      if (q.dataset.bound) return;
      q.dataset.bound = '1';
      q.addEventListener('click', function () {
        var item = q.closest('.faq-item');
        var list = q.closest('.faq-list');
        var isOpen = item.classList.contains('open');
        list.querySelectorAll('.faq-item').forEach(function (i) {
          i.classList.remove('open');
          i.querySelector('.faq-icon').textContent = '+';
          i.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('open');
          q.querySelector('.faq-icon').textContent = '−';
          q.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ── Audio buttons: any [data-audio-toggle] with a sibling <audio> ── */
  function initAudio(scope) {
    (scope || document).querySelectorAll('[data-audio-toggle]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var audio = document.getElementById(btn.dataset.audioToggle);
      if (!audio) return;
      var playLabel = btn.dataset.playLabel || btn.textContent;
      var pauseLabel = btn.dataset.pauseLabel || '❚❚ Pause';
      btn.addEventListener('click', function () {
        // pause every other audio on the page
        document.querySelectorAll('audio').forEach(function (a) {
          if (a !== audio && !a.paused) { a.pause(); }
        });
        document.querySelectorAll('[data-audio-toggle]').forEach(function (b) {
          if (b !== btn) b.textContent = b.dataset.playLabel || b.textContent;
        });
        if (audio.paused) { audio.play(); btn.textContent = pauseLabel; }
        else { audio.pause(); btn.textContent = playLabel; }
      });
      audio.addEventListener('ended', function () { btn.textContent = playLabel; });
      audio.addEventListener('pause', function () { btn.textContent = playLabel; });
    });
  }

  /* ── Product gallery + colour/variant switching ── */
  function initProduct(scope) {
    (scope || document).querySelectorAll('[data-product-root]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';

      var variants = JSON.parse(root.querySelector('[data-variants-json]').textContent);
      var mainImg = root.querySelector('[data-main-media]');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('.thumb'));
      var variantInput = root.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add-to-cart]');
      var priceNow = root.querySelector('[data-price-current]');
      var priceWas = root.querySelector('[data-price-original]');
      var priceSave = root.querySelector('[data-price-save]');
      var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
      var selected = {};

      root.querySelectorAll('[data-option-index]').forEach(function (group) {
        var idx = parseInt(group.dataset.optionIndex, 10);
        var active = group.querySelector('.active');
        if (active) selected[idx] = active.dataset.value;
        group.querySelectorAll('[data-value]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('active'); });
            btn.classList.add('active');
            selected[idx] = btn.dataset.value;
            update();
            if (group.dataset.filtersMedia === 'true') filterMedia(btn.dataset.value);
          });
        });
      });

      function money(cents) {
        var amount = (cents / 100);
        var str = (amount % 1 === 0) ? amount.toFixed(0) : amount.toFixed(2);
        return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, str);
      }

      function currentVariant() {
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return selected[i] === undefined || selected[i] === opt; });
        });
      }

      function update() {
        var v = currentVariant();
        if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.dataset.unavailableLabel || 'Unavailable'; } return; }
        if (variantInput) variantInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        if (priceWas) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceWas.textContent = money(v.compare_at_price); priceWas.hidden = false;
            if (priceSave) { priceSave.textContent = (priceSave.dataset.prefix || 'Save ') + money(v.compare_at_price - v.price); priceSave.hidden = false; }
          } else { priceWas.hidden = true; if (priceSave) priceSave.hidden = true; }
        }
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (addBtn.dataset.addLabel || 'Add to Cart') : (addBtn.dataset.soldoutLabel || 'Sold out');
        }
        if (history.replaceState) {
          var url = new URL(window.location); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
        }
      }

      /* Media filtering: a media item belongs to a colour if its alt text contains the colour name.
         If no media matches the selected colour, all media is shown. */
      function filterMedia(value) {
        var needle = (value || '').toLowerCase();
        var matches = thumbs.filter(function (t) { return (t.dataset.alt || '').toLowerCase().indexOf(needle) !== -1; });
        var show = matches.length ? matches : thumbs;
        thumbs.forEach(function (t) { t.hidden = show.indexOf(t) === -1; });
        setMain(show[0]);
      }

      function setMain(thumb) {
        if (!thumb || !mainImg) return;
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (thumb.dataset.mediaType === 'video') {
          var vid = document.createElement('video');
          vid.src = thumb.dataset.src; vid.controls = true; vid.autoplay = true; vid.muted = true; vid.loop = true; vid.playsInline = true;
          vid.setAttribute('data-main-media', '');
          mainImg.replaceWith(vid); mainImg = vid;
        } else {
          if (mainImg.tagName === 'VIDEO') {
            var img = document.createElement('img'); img.setAttribute('data-main-media', '');
            mainImg.replaceWith(img); mainImg = img;
          }
          mainImg.src = thumb.dataset.src;
          mainImg.alt = thumb.dataset.alt || '';
        }
      }

      thumbs.forEach(function (t) { t.addEventListener('click', function () { setMain(t); }); });

      // initial state: filter by initially-selected colour if configured
      var mediaGroup = root.querySelector('[data-filters-media="true"]');
      if (mediaGroup) { var a = mediaGroup.querySelector('.active'); if (a) filterMedia(a.dataset.value); }
      update();

      /* AJAX add to cart */
      var form = root.querySelector('form[data-product-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var v = currentVariant();
          if (!v || !v.available) return;
          var original = addBtn.textContent;
          addBtn.textContent = addBtn.dataset.addingLabel || 'Adding…';
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: v.id, quantity: 1 })
          }).then(function (r) { return r.json(); }).then(function () {
            addBtn.textContent = addBtn.dataset.addedLabel || 'Added ✓';
            fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
            });
            setTimeout(function () { addBtn.textContent = original; }, 1800);
            if (root.dataset.redirectToCart === 'true') window.location.href = window.Shopify.routes.root + 'cart';
          }).catch(function () { addBtn.textContent = original; form.submit(); });
        });
      }
    });
  }

  function initAll(scope) { initFaq(scope); initAudio(scope); initProduct(scope); }
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  /* Theme editor: re-bind when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
